import React from "react";
import PropTypes from "prop-types";
import { Upload, Button, Icon } from "antd";
import { getAuthToken } from "utilities";
import { PermissionContextConsumer } from "hocs";

const uploaderProps = {
    name: "file",
    action: null,
    headers: {
        Authorization: `Bearer ${getAuthToken()}`
    }
};

export default (componentName, buttonName, uploadUrl, permission) => {
    const FileUploader = value => {
        const upload = (
            <Upload {...{ ...uploaderProps, action: uploadUrl }}>
                <Button>
                    <Icon type="upload" /> {buttonName}
                </Button>
            </Upload>
        );
        if (permission) {
            return (
                <PermissionContextConsumer>
                    {context => (context.get(permission) ? upload : value)}
                </PermissionContextConsumer>
            );
        }
        return upload;
    };
    FileUploader.propTypes = {
        file: PropTypes.string
    };

    return FileUploader;
};
